import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { auditActions } from "store/actions";
import { getSpRosteringSetting } from "store/selector/sp.selector";
import { canViewAuditLogActivity } from "helpers/RolesPermission";
import ActivityTimeline from "./ActivityTimeline";

const ActivityTab = ({ entityType, entityId }) => {
  const dispatch = useDispatch();
  const spRosteringSetting = useSelector(getSpRosteringSetting);
  const canView = canViewAuditLogActivity(spRosteringSetting);
  const loading = useSelector((state) =>
    state.audit?.get("entityActivityLoading")
  );
  const activityData = useSelector((state) =>
    state.audit?.get("entityActivity")
  );
  const [page, setPage] = useState(1);
  const [allActivities, setAllActivities] = useState([]);

  const fetchActivity = useCallback(
    (pageNum) => {
      if (entityType && entityId) {
        dispatch(
          auditActions.getEntityActivityRequest({
            entityType,
            entityId,
            page: pageNum,
          })
        );
      }
    },
    [dispatch, entityType, entityId]
  );

  useEffect(() => {
    if (!canView) return;
    setPage(1);
    setAllActivities([]);
    fetchActivity(1);

    return () => {
      dispatch(auditActions.resetEntityActivity());
    };
  }, [entityType, entityId, fetchActivity, dispatch, canView]);

  useEffect(() => {
    if (activityData?.data) {
      if (activityData.current_page === 1) {
        setAllActivities(activityData.data);
      } else {
        setAllActivities((prev) => [...prev, ...activityData.data]);
      }
    }
  }, [activityData]);

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchActivity(nextPage);
  };

  const hasMore = activityData?.current_page < activityData?.last_page;

  if (!canView) {
    return null;
  }

  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-semibold text-gray-800">
          Activity History
        </h3>
      </div>
      <ActivityTimeline
        activities={allActivities}
        loading={loading}
        onLoadMore={handleLoadMore}
        hasMore={hasMore}
      />
    </div>
  );
};

export default ActivityTab;
